import { render } from "./CanvasInput.vue?vue&type=template&id=08700e24&scoped=true"
import script from "./CanvasInput.vue?vue&type=script&lang=js"
export * from "./CanvasInput.vue?vue&type=script&lang=js"

import "./CanvasInput.vue?vue&type=style&index=0&id=08700e24&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08700e24"]])

export default __exports__